import script from "./AccountStat.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountStat.vue?vue&type=script&setup=true&lang=ts"

import "./AccountStat.vue?vue&type=style&index=0&id=168381ca&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-168381ca"]])

export default __exports__